import React, { Component } from "react";

import DKIcon from "./DKIcon";
// import Components from ".";

/*
PROPS
- icon
- title
- className
- style
- isReverse (boolean)
*/

export default class DKButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onClick: this.props.onClick,
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      onClick: nextProps.onClick,
    });
  }
  render() {
    return (
      <div
        className={
          (this.props.isReverse ? "row-reverse" : "row") +
          " border-radius-m text-wrap-none " +
          this.props.className
        }
        style={{
          ...{
            width: "auto",
            paddingLeft: this.props.title ? 12 : 8,
            paddingRight: this.props.title ? 12 : 8,
            height: 30,
            cursor: "pointer",
            userSelect: "none",
          },
          ...this.props.style,
        }}
        onClick={this.state.onClick ? this.state.onClick : () => {}}
      >
        {this.props.icon && <DKIcon className="ic-s" src={this.props.icon} />}
        {this.props.icon && this.props.title && (
          <div style={{ width: this.props.isReverse ? 5 : 8 }} />
        )}
        <text className="text-align-left text-wrap-none">
          {this.props.title}
        </text>
      </div>
    );
  }
}
